var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.001 3.2002L12.9345 4.0001C12.5883 4.25974 12.1672 4.4001 11.7345 4.4001H9.18143C8.70344 4.4001 8.26647 4.67016 8.0527 5.09769V5.09769C7.7889 5.62528 7.92578 6.26524 8.38231 6.63876L9.77626 7.77927C11.1637 8.91445 11.8817 10.6752 11.6837 12.4569V12.4569C11.6289 12.9505 11.522 13.437 11.365 13.9081L11.2013 14.3993",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.402344 6.79993L2.8665 6.38924C4.01113 6.19847 5.00348 7.19082 4.81271 8.33546L4.72613 8.85495C4.53348 10.0108 5.11724 11.1572 6.16537 11.6813V11.6813C7.00463 12.1009 7.43984 13.0472 7.21226 13.9575L6.80182 15.5992",
    stroke: "white",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.0013,
    cy: 7.99984,
    r: 7.24935,
    stroke: "white",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLand);
export default __webpack_public_path__ + "static/media/land.6dfe38e5a3e1340b720fb39ffb7c3cf2.svg";
export { ForwardRef as ReactComponent };